import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, RequiredValidator, SwitchGroup, TextArea } from '../../../Components/Form';
import { useSendBusinessAdHocNotification } from '../../../Data/Admin';

const SendNotification = ({isOpen, setIsOpen, business}) => {
    return <Modal title="Send a notification" isOpen={isOpen} setIsOpen={setIsOpen}>
        {isOpen && <Inner business={business} />}
    </Modal>
}

const Inner = ({business}) => {
    const {send} = useSendBusinessAdHocNotification();

    const data = {
        businessId: business.id,
        message: 'You have received a reply in the support chat',
        sendPush: true,
        sendSms: false,
        sendEmail: true,
    };

    return <Form data={data} onSubmit={send} closeModalOnSubmit>
        <TextArea name="message" label="Message" validators={[RequiredValidator]} />
        <SwitchGroup label="Channels"
            switches={[
                {name: 'sendPush', label: 'Send Push'},
                {name: 'sendSms', label: 'Send SMS'},
                {name: 'sendEmail', label: 'Send Email'},
            ]}
        />
        <Actions submit={{label: 'Send'}} cancel />
    </Form>
}

export default SendNotification;
